import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppSidebarFooter } from './app-sidebar-footer.component';

@NgModule({
  declarations: [
    AppSidebarFooter
  ],
  imports: [
    BrowserModule
  ],
  exports: [
    AppSidebarFooter
  ]
})
export class AppSidebarFooterModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/app-sidebar/app-sidebar-footer/app-sidebar-footer.module.ts